// 从生成的配置文件读取配置（由 sync-env-mode.js 和 load-infisical-secrets.js 生成）
import { APP_CONFIG } from '../config/generated';
import { logger } from './logger';

let config: any = null;
let configPromise: Promise<any> | null = null;

// Detect if we're in development mode
const isDevelopment = process.env.NODE_ENV === 'development' ||
                     window.location.hostname === 'localhost' ||
                     window.location.hostname === '127.0.0.1';

// 获取当前环境模式（从 generated.ts 或根据 hostname 判断）
function getCurrentMode(): 'dev' | 'test' | 'prod' {
  const mode = APP_CONFIG.mode?.toLowerCase();
  if (mode === 'dev' || mode === 'test' || mode === 'prod') {
    return mode;
  }
  
  // 如果没有配置，根据 hostname 判断
  if (isDevelopment) {
    return 'dev';
  }
  
  // 默认使用 prod
  return 'prod';
}

// 根据 mode 获取对应的配置（从 generated.ts 读取，不再硬编码）
function getEnvConfigByMode() {
  const mode = getCurrentMode();
  return APP_CONFIG.ENV_CONFIGS[mode] || APP_CONFIG.ENV_CONFIGS.prod;
}

logger.log('Environment detection:', {
  NODE_ENV: process.env.NODE_ENV,
  hostname: window.location.hostname,
  isDevelopment,
  currentMode: getCurrentMode(),
  mode: APP_CONFIG.mode
});

export async function loadConfig() {
  if (!configPromise) {
    configPromise = (async () => {
      // 获取环境配置
      const envUrls = getEnvConfigByMode();
      
      // 清理 URL，确保格式正确
      const apiUrl = envUrls.API.replace(/\/$/, '');
      const wsUrl = envUrls.WS.replace(/\/$/, '') + '/';
      const stockUrl = envUrls.STOCK.replace(/\/$/, '') + '/';
      
      // 从 generated.ts 读取配置（从 Infisical 和 .env.general 加载）
      config = {
        API_BASE_URL: apiUrl,
        WS_URL: wsUrl,
        STOCK_WS_URL: stockUrl,
        AWS_REGION: APP_CONFIG.AWS_REGION || 'ap-northeast-1',
        USER_POOL_ID: APP_CONFIG.USER_POOL_ID || '',
        USER_POOL_WEB_CLIENT_ID: APP_CONFIG.USER_POOL_WEB_CLIENT_ID || '',
        OAUTH_DOMAIN: APP_CONFIG.OAUTH_DOMAIN || ''
      };
      
      // 只输出非敏感配置信息
      logger.log('配置加载完成:', {
        API_BASE_URL: apiUrl,
        WS_URL: wsUrl,
        STOCK_WS_URL: stockUrl,
        AWS_REGION: config.AWS_REGION,
        hasUserPoolId: !!config.USER_POOL_ID,
        hasClientId: !!config.USER_POOL_WEB_CLIENT_ID,
        hasOAuthDomain: !!config.OAUTH_DOMAIN
      });
      return config;
    })();
  }
  return configPromise;
}

export function getConfig() {
  if (!config) {
    logger.warn('配置尚未加载，返回默认配置');
    // 使用环境配置
    const envUrls = getEnvConfigByMode();
    return {
      API_BASE_URL: envUrls.API.replace(/\/$/, ''),
      WS_URL: envUrls.WS.replace(/\/$/, '') + '/',
      STOCK_WS_URL: envUrls.STOCK.replace(/\/$/, '') + '/',
      AWS_REGION: APP_CONFIG.AWS_REGION || 'ap-northeast-1',
      USER_POOL_ID: APP_CONFIG.USER_POOL_ID || '',
      USER_POOL_WEB_CLIENT_ID: APP_CONFIG.USER_POOL_WEB_CLIENT_ID || '',
      OAUTH_DOMAIN: APP_CONFIG.OAUTH_DOMAIN || ''
    };
  }
  return config;
}

export async function getConfigAsync() {
  if (!config) {
    await loadConfig();
  }
  return config;
}